import { CommonActions } from '@react-navigation/native';
import { navigationRef } from '@navigation/rootNavigation';

/**
 * Navigate to a Dashboard stack route and clear nested history so the stack
 * remounts at its `initialRouteName` (root screen), regardless of prior state.
 *
 * When `nestedScreen` is provided, the nested stack is reset to that screen only
 * (e.g. Settings → Upgrade).
 *
 * Mobile menu sits outside DashStack in the React tree, so `navigation.reset`
 * on `useNavigation()` targets LoginStack — use the root ref instead.
 */
export function resetToDashboardStackRoot(
  stackName: string,
  nestedScreen?: string,
): void {
  if (!navigationRef.isReady() || !stackName) return;

  const stackRoute = nestedScreen
    ? {
        name: stackName,
        state: {
          index: 0,
          routes: [{ name: nestedScreen }],
        },
      }
    : { name: stackName };

  navigationRef.dispatch(
    CommonActions.reset({
      index: 0,
      routes: [
        {
          name: 'Dashboard',
          state: {
            index: 0,
            routes: [stackRoute],
          },
        },
      ],
    }),
  );
}
